class InternalLinks {
  constructor() {
    this.activeModule = '';
  }

  link(menuElement) {
    menuElement.click();
  }

}

window.navigation = new InternalLinks();
